import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../../tables/tableDevices/tableDevices/big/style/style.css';
import { PREVIEW_URL, VIDEO_PREVIEW_URL } from '../../../const/const';
import IconOnline from '../../icons/iconOnline/IconOnline';
import IconOffline from '../../icons/iconOffline/IconOffline';
import { useSelectedDevice } from '../../../store/devices/SelectedDevice';
import { Device } from '../../../types/Device';
import { useAuthStore } from '../../../store/auth/auth';
import img from './Video.png';

interface CardComponentProps {
    device: Device;
    handleViewVideo: (uid: string) => void;
}

const CardComponent: React.FC<CardComponentProps> = ({ device, handleViewVideo }) => {
    const navigate = useNavigate();
    const { setSelectedDevice } = useSelectedDevice();
    const [mediaUrl, setMediaUrl] = useState<string>('');
    const { SmartDVRToken, user } = useAuthStore.getState();

    const handleDeviceClick = (deviceId: string) => {
        navigate(`/device/${deviceId}`);
        setSelectedDevice(device);
    };

    const handleError = (e: any) => {
        e.target.src = img; // Устанавливаем локальную картинку при ошибке загрузки
    };

    useEffect(() => {
        const loadMedia = async () => {
            try {
                if (!device?.UID || !SmartDVRToken) return;

                const response = await fetch(PREVIEW_URL(device.UID), {
                    headers: {
                        SmartDVRLogin: user?.login || '',
                        SmartDVRToken: SmartDVRToken,
                    },
                });

                if (!response.ok) throw new Error('Failed to fetch media');

                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setMediaUrl(url);
            } catch (error) {
                console.error('Error fetching media:', error);
                setMediaUrl(img);
            }
        };

        loadMedia();

        return () => {
            if (mediaUrl && mediaUrl !== img) {
                URL.revokeObjectURL(mediaUrl);
            }
        };
    }, [device?.UID, SmartDVRToken, user?.login]);

    return (
        <div className="containerCardBig" onClick={() => handleDeviceClick(device.UID)}>
            <div className="coverBig">
                <Card
                    className="coverCardBig"
                    key={device.ID}
                    cover={<img alt={''} src={mediaUrl || img} style={{ borderRadius: 0 }} />}
                    onError={handleError}
                />
            </div>
            <div className="propertiesBig">
                <h1 className="name">
                    <div className="icon">{device.online ? <IconOnline /> : <IconOffline />}</div>
                    {device.name}
                </h1>
            </div>
        </div>
    );
};

export default CardComponent;
